module.exports = __webpack_public_path__ + "img/11.8cd3676b.png";